import { Component, OnInit } from '@angular/core';
import { HttpWrapperService, ApplicationService } from '@picard/services-lib';
import { VouchersModel } from '@picard/models-lib';

@Component({
  selector: 'app-basket-manager',
  templateUrl: './basket-manager.component.html',
  styleUrls: ['./basket-manager.component.css']
})
export class BasketManagerComponent implements OnInit {
  //#region Properties
  voucherCollection: VouchersModel[];
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _httpWrapperService: HttpWrapperService, private _applicationService: ApplicationService) {}
  //#endregion Constructor

  //#region Functions
  async ngOnInit() {
    if (this.docTheme) {
      this.docTheme.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.layout);
    }
    this.voucherCollection = await this._httpWrapperService
      .get('assets/config/mock/vouchers.mock.json', true)
      .toPromise()
      .then(x => x.json());
    console.log(this.voucherCollection);
  }
  //#endregion Functions
}
